import React from 'react';
import ReactDOM from 'react-dom';
import { useMediaQuery } from '@material-ui/core';
import { MUI_MOBILE_BREAKPOINT } from 'src/scripts/utils/constants';
import { LoyaltyTopPanel } from '../Cart/components/Loyalty/LoyaltyTopPanel';
import QRCodeTrigger from '../../../templates/_shared/ui-components/QRCodeModal/QRCodeTrigger';
import QRCodeModal from 'src/scripts/templates/_shared/ui-components/QRCodeModal/QRCodeModal';
import './qr-code-account-header-styles.scss';

const QRCodeAccountHeader = () => {
  const customerData = window.getCustomerInfo ? window.getCustomerInfo() : null;
  const isMobile = useMediaQuery(MUI_MOBILE_BREAKPOINT, { noSsr: true });
  const qrCodeEnabled = window.account_settings?.qr_code_enable || false;
  const shouldShowQRCode = Boolean(customerData?.isCustomer) && isMobile && qrCodeEnabled;

  if (shouldShowQRCode) {
    return (
      <div
        className="qr-account-header qr-enabled"
        style={{ backgroundImage: `url(${window.account_settings?.qr_code_header_background_image})` }}
      >
        <div className="qr-layout-container">
          <LoyaltyTopPanel variant="compact" />
          {Boolean(customerData?.email) && (
            <div className="qr-section">
              <QRCodeTrigger customerEmail={customerData?.email} customerName={customerData?.firstName} />
            </div>
          )}
        </div>
        <QRCodeModal />
      </div>
    );
  }

  return (
    <div className="qr-account-header">
      <LoyaltyTopPanel variant="full" />
    </div>
  );
};

export default QRCodeAccountHeader;

export const InitQRCodeAccountHeader = () => {
  const mountNodes = document.querySelectorAll("[react-render-target='loyalty-top-panel']");
  if (mountNodes.length > 0) {
    return mountNodes.forEach((node) => {
      ReactDOM.render(<QRCodeAccountHeader />, node);
    });
  } else {
    console.warn('missing render targets: loyalty-top-panel');
  }
};
